import superAgent from 'superagent';
import apiCinfig from '../../../api-config';

const loginCredentials = {
    grant_type: apiCinfig.grant_type,
    client_id: apiCinfig.client_id,
    client_secret: apiCinfig.client_secret
};

export const Login = {
    login: (username, password) =>
        new Promise((resolve, reject) => {
            superAgent
                .post(`${apiCinfig.base_url}/users/sessions`)
                .type('form')
                .set({ 'content-type': 'application/x-www-form-urlencoded' })
                .send({
                    ...loginCredentials,
                    username: username,
                    password: password
                })
                .then(response => {
                    resolve({
                        token: response.body.access_token,
                        refresh_token: response.body.refresh_token,
                        token_type: response.body.token_type,
                        expiration_time: response.body.expires_in,
                        username
                    });
                })
                .catch(error => reject(error.response));
        })
};



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-login.js